import { useDebounce } from 'use-debounce'
import { useMediaQuery } from './useMediaQuery'
import { useClientOnlyRender } from './useClientOnlyRender'

/**
 * React hook that returns a boolean, indicating whether the current viewport size is under the specified breakpoint.
 */
export function useResponsiveBreakpoint(breakpoint: number, debounce: boolean = true): boolean {
  useClientOnlyRender()

  const value = useMediaQuery(`(max-width: ${breakpoint}px)`)
  const debouncedValue = useDebounce(value, 200, { maxWait: 500 })

  return debounce ? debouncedValue[0] : value
}
